import React from "react";
import { Box, Button, Paper } from "@mui/material";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';

const DocumentListPage = (props:any) => {

  const documentFiles = props.documentFiles;

  console.log('documentFiles',documentFiles)

  if(documentFiles.length === 0 ) return <></>;
  
  return (
    <Paper sx={{margin: "-56px", borderTop: "4px solid #3e36a5", width:"720px", height:"550px", marginRight:"100px", overflow: "hidden"}}>
      <Box sx={{padding:"20px 8px 8px 8px"}}>
        <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>계약정보 확인 현황</Box>
        <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
        <TableContainer component={Paper} sx={{maxHeight:"440px"}}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="center"><Box sx={{width:"60px", color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>IDX</Box></TableCell>
                <TableCell align="center"><Box sx={{width:"80px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>처리상태</Box></TableCell>
                <TableCell align="center"><Box sx={{color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>파일</Box></TableCell>
                <TableCell align="center"><Box sx={{color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>업로드시간</Box></TableCell>
                {/* <TableCell align="center"><Box sx={{color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>녹음파일</Box></TableCell>
                <TableCell align="center"><Box sx={{color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>자막파일</Box></TableCell>
                <TableCell align="center"><Box sx={{color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>사진파일</Box></TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {documentFiles.map((documentFile:any, idx:number) => (
                
                <React.Fragment key={idx+1}>
                        <TableRow
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                          <TableCell component="th" scope="row" align="center" sx={{width:"80px", fontWeight:700}}>
                            <Box sx={{width:"80px"}}>{documentFile.idx}</Box>
                          </TableCell>
                          <TableCell align="left" sx={{fontWeight:600}}><Button sx={{fontWeight:700, color:"#fff", backgroundColor: (documentFile.state === "문서반려" ? "red" : "#3fb92e")}}>{documentFile.state}</Button></TableCell>
                          <TableCell align="left"><Box>{documentFile.origin_file_name}</Box></TableCell>
                          <TableCell align="left">{documentFile.ins_date}</TableCell>
                          {/* <TableCell align="left">{sample.file_srt}</TableCell>
                          <TableCell align="left">{sample.file_photo}</TableCell> */}
                          </TableRow>
                          {documentFile.reject_rsn != "None" ? 
                          (
                            <TableRow
                              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                              <TableCell align="right" sx={{fontWeight:600}}>
                                <Box><SubdirectoryArrowRightIcon /></Box>
                              </TableCell>
                              <TableCell align="center" sx={{fontWeight:600}}>
                                <Box sx={{width: "80px", height:"20px", color:"#fff", fontWeight:600, backgroundColor:"#caa75b", marginRight:"24px", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>
                                  반려사유
                                </Box>
                              </TableCell>
                              <TableCell colSpan={2} align="left" sx={{fontWeight:600}}>
                                <Box>{documentFile.reject_rsn}</Box>
                              </TableCell>
                            </TableRow>
                          )
                          : ""}
                    </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Paper>
  );
};

export default DocumentListPage;
